import { Observable } from 'rxjs';

import { get } from 'epics/ajax';
import type { UserMention } from './types';
import { contextPath } from 'util/history';

export const fetchUsersJsonWithIssueKey = (
    issueKey: string,
    query: string,
    context: string = contextPath
): Observable<UserMention[]> => {
    const headers = {
        Accept: 'application/json',
    };

    const uri = `${context}/rest/servicedesk/1/customer/mention/${issueKey}/search?q=${query}`;

    return get(uri, headers)
        .map(({ response }) => response)
        .catch((e) => {
            return Observable.throw(e);
        });
};
